import { Link } from "react-router-dom";

export const Logo = () => (
  <Link to="/" data-testid="logo-link" className="flex items-center shrink-0 group">
    <span className="bg-white pl-3 pr-5 py-2 inline-flex items-center">
      <span className="relative">
        <img
          src="/brand/logo.png"
          alt="MODORS Steel Door Frames logo"
          className="h-9 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
        />
        <sup className="absolute -top-1.5 -right-3.5 text-[11px] font-bold leading-none text-brand-ink">
          ™
        </sup>
      </span>
    </span>
  </Link>
);
